export default __webpack_public_path__ + "static/media/element_44.116f9498.jpg";